import { objectHasOwnProperty } from '@domain/validators';
import { DesktopSettings } from '@honestica/electron-bridge-typing';
import { resetFileSettings } from '@launcher/helpers/desktop';
import { logger } from '@services/logger/logger.service';
import { getErrorCode } from '@services/logger/scrubFilePaths';

export async function getSettingsFromFS(): Promise<Partial<DesktopSettings>> {
  try {
    // Await necessary to catch read errors
    return await window.electron.readLocalSettings();
  } catch (error) {
    if (objectHasOwnProperty(error, 'code') && error.code === 'ENOENT') {
      logger.warn('DESKTOP', "Settings file doesn't exist. Creating it.");
      // If there's no file we assume it's the first launch and override registry config
      // TODO(VULN-2157): drop the optional call once the patched desktop app is deployed everywhere
      window.electron.configurePdfCreatorPrinter?.().catch((err: unknown) => {
        logger.error(
          'DESKTOP',
          `Could not configure PDFCreator printer (${getErrorCode(err)})`,
          undefined,
          false,
        );
      });
    } else {
      logger.error(
        'DESKTOP',
        `Invalid settings file. Overriding it (${getErrorCode(error)}).`,
        undefined,
        false,
      );
    }

    return (await resetFileSettings()) || {};
  }
}
